import { render, staticRenderFns } from "./EDTechDetailsIcon.vue?vue&type=template&id=109aa4fc&"
import script from "./EDTechDetailsIcon.vue?vue&type=script&lang=js&"
export * from "./EDTechDetailsIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports